// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/delete.js';

import { paths } from '../generated/delete';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('delete', Original, paths);
